<div class="header bg-primary">
    <div fxLayout="row wrap" fxLayoutAlign="space-between center">
        <h2 class="fw-500 secondary-font">Enregistrer une demande de virement</h2>
        <app-dialog-header-controls [dialogRef]="dialogRef"></app-dialog-header-controls> 
    </div>   
</div>  
<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off" class="pt-3">
    <div mat-dialog-content>
        <div fxLayout="row wrap">
            <div fxFlex="100" class="div-title">
                <span class="title">
                    Vous avez actuellement la somme de 
                    <span class="amount-value">{{data.amount}} {{appService.getCurrency()}} </span>
                    dans votre compte
                </span>
            </div> 
            <div fxFlex="100">
                <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Montant du virement</mat-label>
                    <input matInput formControlName="transfer_amount" required type="number">
                    <mat-error *ngIf="form.controls.transfer_amount.errors?.required">Le montant du virement est requis</mat-error> 
                </mat-form-field>
            </div> 
        </div>
    </div>
    <div mat-dialog-actions>
        <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100"> 
            <button mat-raised-button color="warn" type="button" mat-dialog-close>Annuler</button>
            <button mat-raised-button color="primary" type="submit">Enregistrer</button>
        </div> 
    </div>
</form> 
 